import React from 'react';
import {
  Visa,
  MasterCard,
  Paypal,
  Sofort,
  PaymentTransfer,
  Idealo,
  Haendlerbund,
} from './components';

import styles from './styles/desktop.module.scss';

const PaymentDesktop = () => (
  <div className={styles.container}>
    <div className={styles.section}>
      <div className={styles.block}>
        <Visa className={styles.visa} />
        <MasterCard className={styles.mastercard} />
      </div>
      <div className={styles.block}>
        <Paypal className={styles.paypal} />
        <Sofort className={styles.sofort} />
      </div>
      <div className={styles.block}>
        <PaymentTransfer className={styles.vorkasse} />
      </div>
    </div>
    <div className={styles.award}>
      <div className={styles.awardContainer}>
        <Haendlerbund className={styles.haendlerbund} />
      </div>
    </div>
    <Idealo className={styles.idealo} />
  </div>
);

PaymentDesktop.displayName = 'PaymentDesktop';

export default PaymentDesktop;
